import React, { useState } from 'react';
import apiService from "../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/components.css";

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      toast.error("New passwords do not match.");
      return;
    }

    try {
      const response = await apiService.putData('admin/password', {
        old_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });

      if (response && response.message) {
        toast.success(response.message);
      }
      
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      toast.error("Failed to change password. Please try again.");
    }
  };

  return (
    <div id="app">
      <section className="section">
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-6 col-xl-4">
              {/* <div className="text-center">
                <img src="../assets/img/logo.png" alt="logo" width="250" />
              </div> */}

              <div className="card card-primary">
                <div className="card-header text-center">
                  <h4>Change Password</h4>
                </div>
                <div className="card-body">
                  <div className="form-group">
                    <label>Current Password</label>
                    <input
                      type="password"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      className="form-control"
                      placeholder="Enter Current Password"
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label>New Password</label>
                    <input
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="form-control"
                      placeholder="Enter New Password"
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label>Confirm New Password</label>
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="form-control"
                      placeholder="Re-enter New Password"
                    />
                  </div>
                  <div className="form-group mt-4">
                    <button
                      onClick={handleChangePassword}
                      className="btn btn-primary btn-lg btn-block"
                    >
                      Change Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" autoClose={2000} />
    </div>
  );
};

export default ChangePassword;
